import React, { useState } from "react";
import { Banner, Typography } from "@reconvert/react-ui-component";
import { Box } from "@chakra-ui/react";
import { useAppSelector } from "../../app/hooks";
import { selectAppState } from "../../app/slice/appSlice";
import { PageNames } from "../../app/slice/appSlice.model";
import { useTranslation } from "react-i18next";
import { Slot } from "../../models";
import { IFramePostMessageType, sendPostMessage } from "../../utils/helpers";
import SlotSetupModal from "./SlotSetupModal";
import ChakraSlotSetupModal from "./ChakraSlotSetupModal";

const bannerType = "warning";

const SlotWarningBanner = ({ slot }: { slot: Slot }) => {
  const { t } = useTranslation();
  const { activePage, isEnableAppBridgeModal } = useAppSelector(selectAppState);
  const [isQuickSetupModalOpen, setIsQuickSetupModalOpen] = useState(false);

  const handleQuickSetupModalOpen = () => {
    if (isEnableAppBridgeModal) {
      sendPostMessage(IFramePostMessageType.OPEN_QUICK_SLOT_SETUP_MODAL, {
        slot: slot,
      });
    } else {
      setIsQuickSetupModalOpen(true);
    }
  };

  return (
    <Box mx={"16px"} mt={3} p={2}>  
      <Banner
        title={t("Your slot is not added to the {{pageName}}", { pageName: t(PageNames[activePage!]!) })}
        status={bannerType as any}
        description={t("Please add the slot to your {{pageName}} to ensure your customers see it. Click the button below to be guided through the process step-by-step.", { pageName: t(PageNames[activePage!]!) })
        }
        primaryButton={{
          label: t("Quick setup"),
          onClick: handleQuickSetupModalOpen,
          variant: "link",
        }}
      />
      {isEnableAppBridgeModal ? (
        <SlotSetupModal isOpen={isQuickSetupModalOpen} slot={slot} onClose={() => setIsQuickSetupModalOpen(false)} />
      ) : (
        <ChakraSlotSetupModal
          isOpen={isQuickSetupModalOpen}
          slot={slot}
          onClose={() => setIsQuickSetupModalOpen(false)}
        />
      )}
    </Box>
  );
};

export default SlotWarningBanner;
